export default "__VITE_ASSET__CAbuyVQP__"